import { FC, useEffect } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import AuthPage from '../pages/AuthPage'
import { App } from '../App'
import useAuth from '../../hooks/useAuth'
import { roles } from '../../roles'
import QRCodeScanner from '../../_metronic/layout/components/header/QRCode'
import useGlobals from '../../hooks/useGlobals'
import { ModernFileViewer } from '../pages/FileDisplay/ModernFileViewer'
import DocumentVerifyPage from '../pages/DocumentVerifyPage/index'

const { PUBLIC_URL } = process.env

const getDefaultRoute = (role: string | undefined): string => {
  try {
    if (!role) {
      return '/profile'
    }
    
    const roleIndex = parseInt(role)
    if (isNaN(roleIndex) || roleIndex < 0 || roleIndex >= roles.length) {
      return '/profile'
    }
    
    const roleRoutes = roles[roleIndex]
    if (!roleRoutes || !Array.isArray(roleRoutes) || roleRoutes.length === 0) {
      return '/profile'
    }
    
    return roleRoutes[0] || '/profile'
  } catch (error) {
    console.error('Error in getDefaultRoute:', error)
    return '/profile'
  }
}

const AppRoutes: FC = () => {
  const { me, getMe } = useAuth()

  useEffect(() => {
    getMe({})
  }, [])

  const { actifQrCodeCamera } = useGlobals()

  return (
    <>
      <BrowserRouter basename={PUBLIC_URL}>
        {actifQrCodeCamera && <QRCodeScanner />}
        <Routes>
          <Route element={<App />}>
            <Route path='error/*' element={<ErrorsPage />} />
            {me ? (
              <>
                <Route path='/*' element={<PrivateRoutes />} />
                <Route index element={<Navigate to={getDefaultRoute(me?.role)} />} />
              </>
            ) : (
              <>
                <Route path='/auth/*' element={<AuthPage />} />
                <Route path='/*' element={<Navigate to='/auth' />} />
              </>
            )}
            {/* مسار عرض الملفات */}
            <Route path='/file-viewer' element={<ModernFileViewer />} />
            <Route path='/documents/verify/:code' element={<DocumentVerifyPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  )
}

export { AppRoutes }
